export default __webpack_public_path__ + "static/media/DepositTicketBlack.a4fa6a74.svg";